const LABOR_SALES_TAX_RATE_PERCENT_LABEL: string = 'Sales tax rate (%)';
const LABOR_SALES_TAX_USE_DEFAULT_LABEL: string = 'Use default (no override)';
const LABOR_SALES_TAX_CHARGE_TAX_LABEL: string = 'Charge tax';
const LABOR_SALES_TAX_DO_NOT_CHARGE_TAX_LABEL: string = 'Do not charge tax';
const LABOR_SALES_TAX_JURISDICTION_LABEL: string = 'Jurisdiction';
const LABOR_SALES_TAX_RULES_SECTION_LABEL: string = 'Sales tax';

const CLIENT_FACING_LABOR_SALES_TAX_TOOLTIPS: Readonly<{
  readonly salesTaxRatePercent: string;
  readonly useDefault: string;
  readonly chargeTax: string;
  readonly doNotChargeTax: string;
  readonly jurisdiction: string;
  readonly rulesSection: string;
}> = {
  salesTaxRatePercent:
    'Choose the percent to charge for this jurisdiction when invoicing the client, from 0% to 100%. Required when Charge tax is selected.',
  useDefault:
    'Keep the usual tax setting for this worker type. No custom rule is saved for this province.',
  chargeTax:
    'Charge sales tax for this worker type in the selected province. You must select the tax rate percent.',
  doNotChargeTax:
    'Do not charge sales tax for this worker type in the selected province, even if tax would normally apply.',
  jurisdiction:
    'Choose the province these tax settings apply to. Set Ontario, British Columbia, and Alberta separately.',
  rulesSection:
    'Sales tax settings for invoices for this worker type in Ontario, British Columbia, and Alberta. Client-level overrides can still apply on the organization page.',
};

export {
  CLIENT_FACING_LABOR_SALES_TAX_TOOLTIPS,
  LABOR_SALES_TAX_CHARGE_TAX_LABEL,
  LABOR_SALES_TAX_DO_NOT_CHARGE_TAX_LABEL,
  LABOR_SALES_TAX_JURISDICTION_LABEL,
  LABOR_SALES_TAX_RATE_PERCENT_LABEL,
  LABOR_SALES_TAX_RULES_SECTION_LABEL,
  LABOR_SALES_TAX_USE_DEFAULT_LABEL,
};
